import { ENTORNO } from "../utils/constantes";
import { getToken, getid } from "../utils/variablesLocales";

export class apiViaje {
  baseApi = ENTORNO.BASE_API;

  async calcularSaldoConductor(ChoferId) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_calcularSaldoConductor}?ChoferId=${ChoferId}`;

      const parametros = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarDatosCobro(
    ViajeId,
    Total,
    ComisionImporte,
    Mobbex_Pago_Id,
    Mobbex_Pago_Fecha
  ) {
    try {
      const formData = new FormData();
      formData.append("Total", Total);
      formData.append("ComisionImporte", ComisionImporte);
      formData.append("Mobbex_Pago_Id", Mobbex_Pago_Id);
      formData.append("Mobbex_Pago_Fecha", Mobbex_Pago_Fecha);

      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Actualizar}/${ViajeId}`;

      const parametros = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async valorar(
    ViajeId,
    Rating_LocalPoint,
    Rating_Conductor,
    Rating_Vehiculo,
    ChoferId
  ) {
    try {
      //limpiar viaje en chofer
      const url0 = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Actualizar}/${ChoferId}`;

      const parametros0 = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Viaje_IdViaje: "",
          Viaje_Pasajero: "Disponible",
          Viaje_Estado: "",
          Viaje_Partida: "",
          Viaje_Destino: "",
          Viaje_Min: "",
          Viaje_Kms: "",
          Viaje_PrecioBase: 0,
          Viaje_PrecioSugerido: 0,
          Viaje_VerEnGoogleMaps: "",
          Viaje_PartidaLatitud: "",
          Viaje_PartidaLongitud: "",
          Viaje_UbicacionVehiculoLatitud: "",
          Viaje_UbicacionVehiculoLongitud: "",
          Viaje_MinLlegadaABuscarPasajero: "",
          Viaje_VerEnGoogleMapsRutaBusquedaPasajero: "",
          Viaje_UbicacionAlBuscarPasajeroLatitud: "",
          Viaje_UbicacionAlBuscarPasajeroLongitud: "",
          Viaje_MetrosDistanciaEntreVehiculoYPasajero: 0,
          Viaje_PartidaLocalidad: "",
          Viaje_PartidaProvincia: "",
          Viaje_DestinoLatitud: "",
          Viaje_DestinoLongitud: "",
          Viaje_Saldo: 0,
        }),
      };

      await fetch(url0, parametros0);

      //actualizar estado y valoracion en viaje
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Actualizar}/${ViajeId}`;

      const parametros = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Rating_LocalPoint: Rating_LocalPoint,
          Rating_Conductor: Rating_Conductor,
          Rating_Vehiculo: Rating_Vehiculo,
          Valorado: 1,
          Estado: "VALORADO",
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async cancelar(ViajeId) {
    try {
      //1. cancelo viaje
      const urlViaje = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Actualizar}/${ViajeId}`;
      const parametrosViaje = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          PrecioSugeridoFechaHoraCancelacion: Date.now(),
          Estado: "CANCELADO",
          Activo: 0,
        }),
      };
      await fetch(urlViaje, parametrosViaje);

      //2. cancelo viaje en user
      //obtengo el id del conductor
      const urlUsuarioConductor = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Obtener}?Viaje_IdViaje=${ViajeId}`;
      const parametrosUsuarioConductor = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      const respuestaUsuarioConductor = await fetch(
        urlUsuarioConductor,
        parametrosUsuarioConductor
      );
      const respuestaJsonUsuarioConductor =
        await respuestaUsuarioConductor.json();

      if (respuestaJsonUsuarioConductor[0] === undefined) {
        //no encontro ningun conductor con ese id de viaje
      } else {
        //limpiar datos de viaje en chofer asignado
        const IdConductor = respuestaJsonUsuarioConductor[0]._id;

        const urlUsuarioConductorParaActualizar = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Actualizar}/${IdConductor}`;
        const parametrosUsuarioConductorParaActualizar = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            Viaje_IdViaje: "",
            Viaje_Pasajero: "Disponible",
            Viaje_Estado: "",
            Viaje_Partida: "",
            Viaje_Destino: "",
            Viaje_Min: "",
            Viaje_Kms: "",
            Viaje_PrecioBase: 0,
            Viaje_PrecioSugerido: 0,
            Viaje_VerEnGoogleMaps: "",
            Viaje_PartidaLatitud: "",
            Viaje_PartidaLongitud: "",
            Viaje_UbicacionVehiculoLatitud: "",
            Viaje_UbicacionVehiculoLongitud: "",
            Viaje_MinLlegadaABuscarPasajero: "",
            Viaje_VerEnGoogleMapsRutaBusquedaPasajero: "",
            Viaje_UbicacionAlBuscarPasajeroLatitud: "",
            Viaje_UbicacionAlBuscarPasajeroLongitud: "",
            Viaje_MetrosDistanciaEntreVehiculoYPasajero: 0,
            Viaje_PartidaLocalidad: "",
            Viaje_PartidaProvincia: "",
            Viaje_DestinoLatitud: "",
            Viaje_DestinoLongitud: "",
            Viaje_Saldo: 0,
          }),
        };
        const respuestaUsuarioConductorParaActualizar = await fetch(
          urlUsuarioConductorParaActualizar,
          parametrosUsuarioConductorParaActualizar
        );

        return respuestaUsuarioConductorParaActualizar;
      }
    } catch (error) {
      throw error;
    }
  }

  async obtenerActivos(Id) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_ObtenerActivos}?Valorado=0&Activo=1&UsuarioId=${Id}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async obtenerPRECIO_SUGERIDO() {
    try {
      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Viaje_ObtenerActivos
      }?Activo=1&Estado=PRECIO SUGERIDO&UsuarioId=${getid()}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async nuevo(
    PartidaDireccion,
    PartidaLatitud,
    PartidaLongitud,
    DestinoDireccion,
    DestinoLatitud,
    DestinoLongitud,
    Kms,
    Min,
    PrecioBase,
    Localidad,
    Provincia,
    Pasajero,
    VerEnGoogleMaps
  ) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_Nuevo}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          UsuarioId: getid(),
          FechaHoraSolicitud: Date.now(),
          PartidaDireccion: PartidaDireccion,
          PartidaLatitud: PartidaLatitud,
          PartidaLongitud: PartidaLongitud,
          DestinoDireccion: DestinoDireccion,
          DestinoLatitud: DestinoLatitud,
          DestinoLongitud: DestinoLongitud,
          Kms: Kms,
          Min: Min,
          PrecioBase: PrecioBase,
          PrecioSugerido: PrecioBase,
          PrecioSugeridoFechaHoraSugerencia: null,
          ChoferId: "",
          Chofer: "",
          Marca: "",
          Modelo: "",
          Color: "",
          Dominio: "",
          PrecioSugeridoFechaHoraAceptacion: null,
          PrecioSugeridoFechaHoraCancelacion: null,
          Estado: "PENDIENTE",
          Localidad: Localidad,
          Provincia: Provincia,
          Activo: 1,
          DatosOperacion: "",
          LlegasteADestino: -1,
          Rating_LocalPoint: 0,
          Rating_Conductor: 0,
          Rating_Vehiculo: 0,
          Valorado: 0,
          ComisionImporte: 0,
          Total: PrecioBase,
          ImporteAcreditado: 0,
          FechaAcreditacion: Date.now(),
          Pasajero: Pasajero,
          VerEnGoogleMaps: VerEnGoogleMaps,
          UbicacionVehiculoLatitud: "",
          UbicacionVehiculoLongitud: "",
          MinLlegadaABuscarPasajero: "",
          VerEnGoogleMapsRutaBusquedaPasajero: "",
          UbicacionAlBuscarPasajeroLatitud: "",
          UbicacionAlBuscarPasajeroLongitud: "",
          MetrosDistanciaEntreVehiculoYPasajero: 0,
          Mobbex_Pago_Id: "",
          Mobbex_Pago_Fecha: "",
          Saldo: PrecioBase,
          Mobbex_BotonDePago: "",
          Mobbex_BotonDePago_DatosOperacion: "",
          Mobbex_BotonDePago_FechaPago: Date.now(),
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async obtenerMisViajesPasajero(Id, Periodo) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_HistorialDeViajes_Pasajero}?UsuarioId=${Id}&Periodo=${Periodo}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async obtenerMisViajesConductor(Id, Periodo) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_MisViajes_Conductor}?ChoferId=${Id}&Periodo=${Periodo}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async obtenerViaje_ParaBancoOpg() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_ParaBancoOpg}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async obtenerViaje_ParaBancoRet() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_ParaBancoRet}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async importarResultadoBanco(Archivo) {
    try {
      const formData = new FormData();
      formData.append("Archivo", Archivo);

      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_ImportarResultadoBanco}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async obtener(ViajeId) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_ObtenerActivos}?_id=${ViajeId}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async refrescarHome(ViajeId, Estado) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_refrescarHome}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          ViajeId: ViajeId,
          Estado: Estado,
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async refrescarHomePorToken(TokenNotificacion, Mensaje, role) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Viaje_refrescarHomePorToken}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          TokenNotificacion: TokenNotificacion,
          Mensaje: Mensaje,
          role: role,
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }
}
